import {BaseResponse} from '../../response/internal/baseresponse';
export class LicenseBlur {
  image: string;
  type: string;
  front: boolean;
}


export class ResponseLicenseBlur extends BaseResponse {
  data: LicenseBlur;
}



// WEBPACK FOOTER //
// ./src/app/view-model/agent/licenseblur.ts